import getIndustries from './get-industries.api';

const industriesApi = {
  getIndustries,
};

export default industriesApi;
